import { Auth } from "aws-amplify";
import { useEffect, useState } from "react";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import Footer from "../pages/footer";
import NavBar from "../pages/navbar";
import { clientConfig } from "../awsClientConfig";
import SideBar from "../../src/pages/sidebar";
import useProfileStore, {
  useGroupStore,
  PrimaryGroups,
} from "../store/ProfileStore";
import { fetchQuery } from "../functions/misc";
import { GetProfile } from "../queries/getProfile";
import { userProfileData } from "./profileInfo";
import background from "../assets/background.png";
import PartnerSideBar from "../pages/PartnerSideBar";
import { encodeToBase64, decodeFromBase64 } from "../functions/misc";
import MobileNavBar from "../pages/MobileNavBar";
import PartnerSideBarV2 from "../pages/PartnerSideBarV2";
import SidebarV2 from "../pages/sidebarV2";
import { Layout as DashboardLayout } from "../components/layout/layout";
import { Provider } from "../components/layout/layout-context";
import { useClearStores } from "../hooks/use-clear-stores";

export interface TpoIframeUrlType {
  tpoIframeUrl: string;
  setTpoIframeUrl: (url: string) => void;
}

const CommonLayoutV2 = () => {
  const client = new clientConfig();
  const navigate = useNavigate();
  const [hideSidebar, setHideSidebar] = useState(false);
  const [tpoIframeUrl, setTpoIframeUrl] = useState<string>("");
  const [partner, setPartner] = useState(false);
  const location = useLocation();
  const { partnerProfile, setPartnerProfile, spouseProfile, setSpouseProfile } =
    useProfileStore();
  const { primaryGroup, setPrimaryGroup } = useGroupStore();
  const [hamburgerMenuOpen, setHamburgerMenuOpen] = useState(false);
  const [enrolmentSource, setEnrolmentSource] = useState("");
  const clearAllStores = useClearStores();

  useEffect(() => {
    userAuthCheck();
  }, []);

  useEffect(() => {
    trackRouteChange();
  }, [location.pathname]);

  const userAuthCheck = async () => {
    Auth.currentAuthenticatedUser()
      .then((res) => {
        if (res) {
          if (res.attributes["custom:Group"]) {
            const group = encodeToBase64(res.attributes["custom:Group"]);
            setPrimaryGroup(group);
          }
          console.log("user found");
        } else {
          clearAllStores();
          navigate("/");
        }
      })
      .catch((error) => {
        if (error) {
          clearAllStores();
          navigate("/");
        }
      });
    const profileId = await userProfileData();
    const getProfile = await fetchQuery({ profileId: profileId }, GetProfile);
    setEnrolmentSource(
      getProfile?.EnrollmentSource ? getProfile?.EnrollmentSource : ""
    );
    if (getProfile?.ParentId) {
      setSpouseProfile({
        Id: getProfile.Id,
        AccountId: getProfile.AccountId,
        ParentId: getProfile.ParentId,
        FirstName: getProfile.FirstName,
        LastName: getProfile.LastName,
        Email: getProfile.Email
      });
    }
  };

  const trackRouteChange = () => {
    if (tpoIframeUrl && tpoIframeUrl.includes("login?")) {
      setTpoIframeUrl(
        `${process.env.REACT_APP_LEGACY_CLIENT_PORTAL_URL}/login`
      );
    }
    if (
      location.pathname === "/client-profile" ||
      location.pathname === "/partner-profile" ||
      location.pathname === "/protection-plan" ||
      location.pathname === "/res-protection-plan" ||
      location.pathname === "/partner-enrollment"
    ) {
      setHideSidebar(true);
    } else {
      setHideSidebar(false);
    }
  };

  const isShowPartnerSideBar = () => {
    return (
      !hideSidebar && decodeFromBase64(primaryGroup) === PrimaryGroups.Partner
    );
  };

  const isShowClientSideBar = () => {
    return (
      !hideSidebar &&
      !spouseProfile?.ParentId &&
      !partnerProfile?.Email &&
      decodeFromBase64(primaryGroup) !== PrimaryGroups.Partner
    );
  };

  const hamburgerMenuHandler = () => {
    if (hamburgerMenuOpen) {
      setHamburgerMenuOpen(false);
      /*if(document.getElementById("main-outlet")) {
        (document.getElementById("main-outlet") as HTMLElement).style.opacity = "1";
      }*/
    } else {
      setHamburgerMenuOpen(true);
      if (document.getElementById("sidebarMenu")) {
        (document.getElementById("sidebarMenu") as HTMLElement).style.display =
          "inline";
      }
      /*if(document.getElementById("main-outlet")) {
        (document.getElementById("main-outlet") as HTMLElement).style.backgroundColor = "black";
        (document.getElementById("main-outlet") as HTMLElement).style.opacity = "0.5";
      }*/
    }
  };

  const onMainOutletClickHandler = () => {
    if (hamburgerMenuOpen) hamburgerMenuHandler();
  };

  return (
    <Provider value={{ enrolmentSource, setEnrolmentSource }}>
      <DashboardLayout hideSidebar={hideSidebar}>
        <Outlet />
      </DashboardLayout>
    </Provider>
  );
};

export default CommonLayoutV2;
